import { MapPin, Scale, FileCheck } from "lucide-react";

  const items = [
  {
    icon: MapPin,
    title: "Address Verification",
    body: "Verify a candidate's current or past residence via field visits, digital footprint validation and postal confirmations — including overseas addresses.",
  },
  {
    icon: Scale,
    title: "Litigation Checks",
    body: "Court record search across civil and criminal jurisdictions. Choose Civil, Criminal, or combined Civil + Criminal scope.",
  },
  {
    icon: FileCheck,
    title: "ID Checks",
    body: "Authenticate passports, national IDs, driving licenses and other government issued IDs against source registries.",
  },
];

export default function ServicesPage() {
  return (
    <div className="max-w-6xl mx-auto px-5 lg:px-8 py-20">
      <div className="font-mono-data text-[11px] uppercase tracking-[0.2em] text-[#1E3A8A]">What we do</div>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900 mt-3">Our verification services</h1>
      <p className="mt-4 text-slate-600 max-w-2xl leading-relaxed">
        Every check has a fixed data intake and a clean, auditable status trail inside your client portal.
      </p>

      <div className="mt-12 space-y-8">
        {items.map(({ icon: Icon, title, body }) => (
          <div key={title} className="card-elevate border border-slate-200 rounded-2xl bg-white p-8">
            <div className="w-12 h-12 rounded-xl bg-[#1E3A8A] text-white grid place-items-center"><Icon size={22} /></div>
            <h2 className="mt-5 font-display text-2xl font-bold text-slate-900">{title}</h2>
            <p className="mt-2 text-sm text-slate-600 leading-relaxed">{body}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
